import { render, staticRenderFns } from "./ScrollySvgCustom.vue?vue&type=template&id=9f7a3e46&"
import script from "./ScrollySvgCustom.vue?vue&type=script&lang=js&"
export * from "./ScrollySvgCustom.vue?vue&type=script&lang=js&"
import style0 from "./ScrollySvgCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports